import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Icon, Button } from 'shared/components';
import { AccessibilityContext } from 'App';

import theme from './ModalRetryUploadMeta.scss';

const propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  fileName: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  onOk: PropTypes.func.isRequired,
};

const defaultProps = {};

const ModalRetryUploadMeta = ({
  intl,
  fileName,
  onCancel,
  onOk,
}) => (
  <div className={ theme.root }>
    <div className={ theme.header }>
      <div className={ theme.iconContainer }>
        <Icon className={ theme.icon } name="exclamation" />
      </div>
      <div>
        <FormattedMessage id="modal.retryUploadMeta.title" defaultMessage="** Upload Failed" />
      </div>
      <button onClick={ onCancel } className={ theme.closingIconContainer } aria-label={ intl.formatMessage({ id: 'General.Cancel', defaultMessage: '** Cancel' }) }>
        <Icon name="naked-x" />
      </button>
    </div>

    <div className={ theme.content }>
      <FormattedMessage
        id="modal.retryUploadMeta.body"
        defaultMessage="** There was a problem uploading the file { fileName } you tried to upload is not approved. You can try uploading it again or delete it permanenly."
        values={{ fileName }}
      />
    </div>

    <div className={ theme.footer }>
      <Button
        testId="modal-retry-upload-file-delete-button"
        label={ intl.formatMessage({ id: 'modal.retryUploadMeta.deleteButton', defaultMessage: '** Delete Permanenly' }) }
        className={ theme.cancelButton }
        background="red"
        onClick={ onCancel }
      />

      <Button
        testId="modal-upload-file-retry-button"
        label={ intl.formatMessage({ id: 'modal.retryUploadMeta.retryButton', defaultMessage: '** Upload Again' }) }
        onClick={ onOk }
      />
    </div>
  </div>
);

ModalRetryUploadMeta.propTypes = propTypes;
ModalRetryUploadMeta.defaultProps = defaultProps;

export default ModalRetryUploadMeta;
